__turbopack_context__.v({
  "actionMenu": "styles-module__kB8eLG__actionMenu",
  "avatarNotification": "styles-module__kB8eLG__avatarNotification",
  "avatarWrapper": "styles-module__kB8eLG__avatarWrapper",
  "avatar__initials": "styles-module__kB8eLG__avatar__initials",
  "dropdownArrow": "styles-module__kB8eLG__dropdownArrow",
  "isActive": "styles-module__kB8eLG__isActive",
  "isOpen": "styles-module__kB8eLG__isOpen",
  "navItem": "styles-module__kB8eLG__navItem",
  "wrapper": "styles-module__kB8eLG__wrapper",
});
